import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p400500994272649216',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
